export const ADYA_USER_QUERY_ACTION = 'ADYA_USER_QUERY_ACTION';